import { ParamMap } from '@angular/router';
import { LocalDate } from '../../core/model/local-date';
import { readEnumParam, readIntegerParam, readLocalDateParam } from '../../core/service/list-query-params';
import { LeaseAgreementStatus, TerminationMonitoringStatus } from '../model/const/enums';

export interface ContractListDrilldownQuery {
  status?: LeaseAgreementStatus;
  terminationMonitoringStatus?: TerminationMonitoringStatus;
  fixedTermExpirationStatus?: number;
  securityOfTenureExpirationStatus?: number;
  fromDateStart?: LocalDate;
  fromDateEnd?: LocalDate;
  terminationDateStart?: LocalDate;
  terminationDateEnd?: LocalDate;
  selectedFields: string[];
  isExternal: boolean;
}

export function parseContractListDrilldownQuery(params: ParamMap): ContractListDrilldownQuery {
  const status = readEnumParam(params, 'status', LeaseAgreementStatus);
  const terminationMonitoringStatus = readEnumParam(params, 'terminationMonitoringStatus', TerminationMonitoringStatus);
  const fixedTermExpirationStatus = readIntegerParam(params, 'fixedTermExpirationStatus', 3, 12);
  const securityOfTenureExpirationStatus = readIntegerParam(params, 'securityOfTenureExpirationStatus', 3, 12);
  const fromDateStart = readLocalDateParam(params, 'fromDateStart');
  const fromDateEnd = readLocalDateParam(params, 'fromDateEnd');
  const terminationDateStart = readLocalDateParam(params, 'terminationDateStart');
  const terminationDateEnd = readLocalDateParam(params, 'terminationDateEnd');
  const selectedFields: string[] = [];

  if (status !== undefined) selectedFields.push('status');
  if (terminationMonitoringStatus !== undefined) selectedFields.push('terminationMonitoringStatus');
  if (fixedTermExpirationStatus !== undefined) selectedFields.push('fixedTermExpirationStatus');
  if (securityOfTenureExpirationStatus !== undefined) selectedFields.push('securityOfTenureExpirationStatus');
  if (fromDateStart) selectedFields.push('fromDateStart');
  if (fromDateEnd) selectedFields.push('fromDateEnd');
  if (terminationDateStart) selectedFields.push('terminationDateStart');
  if (terminationDateEnd) selectedFields.push('terminationDateEnd');

  return {
    status,
    terminationMonitoringStatus,
    fixedTermExpirationStatus,
    securityOfTenureExpirationStatus,
    fromDateStart,
    fromDateEnd,
    terminationDateStart,
    terminationDateEnd,
    selectedFields,
    isExternal: selectedFields.length > 0,
  };
}
